import { Injectable, Inject } from '@angular/core';
import { MessageConfig } from '../_models/message-config';
import { WINDOW } from '../_services/window.service';
import { LoggerService } from '../_services/logger.service';
import { ParentMessage } from '../_models/parent-message';

@Injectable({
  providedIn: 'root'
})
export class ParentMessageService {
  _messageConfigs: Array<MessageConfig> = [];

  constructor(
    @Inject(WINDOW) private window: Window,
    private logger: LoggerService
  ) {    
    this.window.addEventListener('message', (event) => {
      this.logger.log("ParentMessageService - receiveMessage");      

      if (event.data.hasOwnProperty("data")) {
        this.logger.log("ParentMessageService - receiveMessage - no custom message");
        this.logger.log(event.data);
        
        return;
      }

      var message: ParentMessage = event.data;
      this.logger.log(message);

      for (var messageConfigId in this._messageConfigs) {        
        if (this._messageConfigs.hasOwnProperty(messageConfigId) && messageConfigId === message.id) {
          this.logger.log("ParentMessageService - receiveMessage: call handler for message " + message.id);

          var messageConfig =  this._messageConfigs[messageConfigId];          

          messageConfig.handler.call(messageConfig.context, message);
        }
      }
    });
  }

  register(messageConfig) {
    this._messageConfigs[messageConfig.id] = messageConfig;
  };

  sendMessage(message: ParentMessage, window: Window = null) {
    try {
      if (window !== null) {
        this.logger.log("ParentMessageService - sendMessage - to custom window");
        this.logger.log(message);

        window.postMessage(message, '*');
      } else if (this.isIframe() === true) {
        this.logger.log("ParentMessageService - sendMessage - to parent window");
        this.logger.log(message);

        this.window.parent.postMessage(message, '*');
      } else if (this.isChild() === true) {
        this.logger.log("ParentMessageService - sendMessage - to opener window");
        this.logger.log(message);

        this.window.opener.postMessage(message, '*');
      } else {
        this.logger.error("ParentMessageService - sendMessage - no windows to send message");
        this.logger.error(message);
      }
    } catch (e) {
      this.logger.error("ParentMessageService - sendMessage: " + e);
    }
  };

  private isIframe() {
    if (this.window.self === this.window.top) {
      return false;
    } else {
      return true;
    }
  };

  private isChild() {
    if (this.window.opener && !this.window.opener.closed) {
      return true;
    } else {
      return false;
    }
  };

}
